import { render, staticRenderFns } from "./catalog-tag-page.vue?vue&type=template&id=c1947b5a&"
import script from "./catalog-tag-page.vue?vue&type=script&lang=ts&"
export * from "./catalog-tag-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports